/** Browser-safe map SDK keys from GET /api/config (Worker secrets). */
export interface StreetViewPublicKeys {
  naver_map_key_id: string | null;
  kakao_map_js_key: string | null;
}

/** External Naver street view tab needs the Naver Maps JS key id. */
export function naverStreetViewAvailable(keys: StreetViewPublicKeys): boolean {
  return Boolean(keys.naver_map_key_id?.trim());
}

export function normalizeStreetViewKeys(raw: {
  naver_map_key_id?: string | null;
  kakao_map_js_key?: string | null;
}): StreetViewPublicKeys {
  const naver = raw.naver_map_key_id?.trim() || null;
  const kakao = raw.kakao_map_js_key?.trim() || null;
  return { naver_map_key_id: naver, kakao_map_js_key: kakao };
}
